import {
    GET_GD_UNIT_STATE,
    SET_DIVIDER_LABEL,
    GD_UNIT_CODE_VALIDATION_STATUS
} from '../constants';

export default (state = {}, action) => {
    switch (action.type) {
        case GET_GD_UNIT_STATE:
            return {
                ...state,
                adUnitState: action.payload
            }
        case SET_DIVIDER_LABEL:
            return {
                ...state,
                dividerLabel: action.payload
            }
        case GD_UNIT_CODE_VALIDATION_STATUS:
            return {
                ...state,
                isAdUnitCodeValid: action.payload
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/gdUnitControlPanelReducer.js